import {injectable, decorate} from 'inversify';
import {siteSettingsApi} from '../../env/siteSettings/siteSettingsApi';
import {ISiteSettingsProvider} from './ISiteSettingsProvider';

export class SiteSettingsProvider implements ISiteSettingsProvider {
  obtain() {
    return siteSettingsApi.obtain();
  }
}

decorate(injectable(), SiteSettingsProvider);
